import { type ReactNode } from 'react';
import { type PairingDetail } from '@hungryroot/rest';
import { usePairing } from '@hungryroot/rest';

interface PairingLoaderProps {
  id: number;
  children: (props: { pairing?: PairingDetail }) => ReactNode;
  outOfStockOptions?: {
    inventory_date: string | null;
    origin: number | null;
  };
}

export function PairingLoader(props: PairingLoaderProps) {
  const { id, children, outOfStockOptions = {} } = props;
  const { data: pairing } = usePairing({ id, ...outOfStockOptions });

  return children({ pairing });
}
